class Color {

	get LIGHT() { return 'light'; }
	get GREY() { return 'grey'; }
	get DARK() { return 'dark'; }

}

export default new Color();
